import { ILocationPath, Location } from './location';
import { GoogleCloudStorageLinkedService } from '../../linkedservice/google-cloud-storage.linkedservice';
import { Metamodel } from '../../base/model';
import { IAttribute, IModel } from '../../base/annotation';
import { FilePath } from '../file-path';
import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';
import { shellStringResources } from '../../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'GoogleCloudStorageLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(GoogleCloudStorageLinkedService)
    }
})
export class GoogleCloudStorageLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly CONTAINER: IAttribute;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Container,
        association: 'CONTAINER',
        templatable: true
    })
    public container?: string;

    @Metamodel.attribute({
        display: shellStringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
        this.container = path.container;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', GoogleCloudStorageLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', GoogleCloudStorageLocation.FILE_NAME, path);
        this.setPathPropertyValue('container', GoogleCloudStorageLocation.CONTAINER, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        path.container = this.container;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: GoogleCloudStorageLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: GoogleCloudStorageLocation.FILE_NAME.templateValue(this) || this.fileName,
            container: GoogleCloudStorageLocation.CONTAINER.templateValue(this) || this.container
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && GoogleCloudStorageLocation.FILE_NAME.templateValue(this) ? false : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(GoogleCloudStorageLocation.CONTAINER.templateValue(this)) ||
            !stringIsNullOrEmpty(GoogleCloudStorageLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(GoogleCloudStorageLocation.FILE_NAME.templateValue(this));
    }
}
